import React from "react";
import "../styles/GoogleMap.css";

const GoogleMap: React.FC = () => {

    const src =
        "https://maps.google.com/maps?q=Panev%C4%97%C5%BEys&z=12&output=embed";

    return (
        <section className="map-section">
            <div className="map-card">
                <iframe
                    className="google-map"
                    src={src}
                    title="Panevėžys"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
        </section>
    );
};

export default GoogleMap;
